import { render, staticRenderFns } from "./Competenze.vue?vue&type=template&id=06ee0960&"
import script from "./Competenze.vue?vue&type=script&lang=js&"
export * from "./Competenze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports